import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './styles.css';

interface PlayBackButtonProps {
  onClick: () => void;
  isPaused: boolean;
}

const easeOutQuint = (x: number): number => {
  return 1 - Math.pow(1 - x, 5);
};

const PlayBackButton: React.SFC<PlayBackButtonProps> = ({
  onClick,
  isPaused,
}) => {
  const [inited, setInited] = useState(false);
  // @ts-ignore: Ignore type error from react spring. reference: https://github.com/react-spring/react-spring/issues/858
  const outter = useSpring({
    // @ts-ignore
    from: { scale: 1 },
    to: inited ? [{ scale: 1 }, { scale: 0.9 }, { scale: 1 }] : [{ scale: 1 }],
    config: { duration: 1000, easing: easeOutQuint },
    onRest: () => !isPaused && setInited(!inited),
  });
  // @ts-ignore
  const inner = useSpring({
    // @ts-ignore
    from: { scale: 1 },
    to: inited ? [{ scale: 1 }, { scale: 1.1 }, { scale: 1 }] : [{ scale: 1 }],
    config: { duration: 1000, easing: easeOutQuint },
    onRest: () => !isPaused && setInited(!inited),
  });

  return (
    <animated.div
      className="audio-player__play-back-button"
      onClick={() => {
        setInited(true);
        onClick();
      }}
      data-enable-ga
      data-ga-type="button"
      data-ga-text={isPaused ? 'play' : 'pause'}
    >
      <animated.div
        className="audio-player__play-back-button-outter"
        style={{
          // @ts-ignore
          transform: outter.scale.interpolate(
            (scale: any) => `scale(${scale})`,
          ),
        }}
      />
      <animated.div
        className="audio-player__play-back-button-inner"
        style={{
          // @ts-ignore
          transform: inner.scale.interpolate((scale: any) => `scale(${scale})`),
        }}
      />
      {isPaused ? (
        <div className="audio-player__button-play" />
      ) : (
        <div className="audio-player__button-pause" />
      )}
    </animated.div>
  );
};

PlayBackButton.defaultProps = {
  onClick: () => {},
  isPaused: true,
};

export default React.memo(PlayBackButton);
